var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Alert, AlertTitle, Box, Card } from "@mui/material";
import { useWebgate } from "@xvia/webgate-connect";
import { useHistory } from "react-router-dom";
import useLoading from "../../hooks/Loading";
import CardOrgao from "../CardOrgao";
import styles from "./index.module.css";
import * as Muicon from "@mui/icons-material";
import { BackButtonWithTitle } from "@opala-ds/react";
import { useEffect, useState } from "react";
import CartilhasService from "../../services/api/CartilhasService";
function HomePage() {
    var _this = this;
    var portalConnect = useWebgate().portalConnect;
    var history = useHistory();
    var _a = useState([]), orgaos = _a[0], setOrgaos = _a[1];
    var _b = useState(false), error = _b[0], setError = _b[1];
    var _c = useState(2), margin = _c[0], setMargin = _c[1];
    var service = new CartilhasService();
    var loading = useLoading();
    var fetchOrgaos = function () { return __awaiter(_this, void 0, void 0, function () {
        var response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, 3, 4]);
                    loading.show();
                    return [4 /*yield*/, service.listAllOrgaos()];
                case 1:
                    response = _a.sent();
                    if (response) {
                        setOrgaos(response);
                    }
                    return [3 /*break*/, 4];
                case 2:
                    error_1 = _a.sent();
                    setError(true);
                    return [3 /*break*/, 4];
                case 3:
                    loading.hide();
                    return [7 /*endfinally*/];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    useEffect(function () {
        fetchOrgaos();
    }, []);
    useEffect(function () {
        setMargin((portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.isRunningInWebview()) ? 0 : 2);
    }, [portalConnect]);
    var handleOnSelectOrgao = function (sigla) { return __awaiter(_this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            history.push("/orgao/".concat(sigla));
            return [2 /*return*/];
        });
    }); };
    var handleBotaoVoltar = function () {
        history.goBack();
    };
    var sort = function (a, b) { return a.id - b.id; };
    if ((orgaos || []).length === 0) {
        loading.show();
        return _jsx(Box, {});
    }
    return (_jsxs(Box, __assign({ id: "container-index b2", sx: { ml: margin, mr: margin } }, { children: [_jsx(Box, __assign({ className: styles.header }, { children: _jsx(BackButtonWithTitle, { textButton: "Voltar", textTitle: "Org\u00E3os", hideBackButton: portalConnect === null || portalConnect === void 0 ? void 0 : portalConnect.isRunningInWebview(), onClick: handleBotaoVoltar }) })), _jsx(Box, __assign({ style: { display: "flex", flexDirection: "column" } }, { children: _jsxs(Card, __assign({ variant: "outlined", sx: { padding: 2 } }, { children: [_jsx("div", __assign({ className: styles.flex }, { children: orgaos.sort(sort).map(function (orgao) {
                                var iconData = orgao.icone || "";
                                var key = iconData;
                                var icone = Muicon["AccountBalance"];
                                if (iconData !== "") {
                                    icone = Muicon[key];
                                }
                                return (_jsx(CardOrgao, { label: orgao.sigla.toUpperCase(), info: orgao.nome, icon: icone, onClick: function () { return handleOnSelectOrgao(orgao.sigla); } }, orgao.sigla));
                            }) })), error && (_jsxs(Alert, __assign({ severity: "warning" }, { children: [_jsx(AlertTitle, { children: "Aten\u00E7\u00E3o: " }), _jsx("p", { children: "N\u00E3o foi poss\u00EDvel carregar os org\u00E3os dispon\u00EDveis. Tente novamente mais tarde." })] })))] })) }))] })));
}
export default HomePage;
